import { api } from '../../api'
import addDealer from './addDealer'
import deleteDealer from './deleteDealer'

import getAllDealers from './getAllDealers'
import getDealerById from './getDealerById'
import updateDealerById from './updateDealerById'


export const dealersApi = api.injectEndpoints({
    endpoints: build => ({
        GetAllDealers:     getAllDealers(build),
        UpdateDealerById:updateDealerById(build),
        AddDealer:addDealer(build),
        GetDealerById:getDealerById(build),
        DeleteDealer:deleteDealer(build)

       
    }),
    overrideExisting: true,
})

export const { 
    // useAddTestimonialMutation,
    // useUpdateTestimonialMutation,
    // useDeleteTestimonialMutation,
    useGetAllDealersQuery,
    useUpdateDealerByIdMutation,
    useAddDealerMutation,
    useGetDealerByIdQuery,
    useDeleteDealerMutation
  
 } = dealersApi

